import * as actionTypes from './actionTypes';
import * as actions from './index';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import { encrypt } from 'Flow2/util/Hash.js';

// **** DISTRIBUTION TREE *** //
export const getDistributionTreeStart = () => {
    return {
        type: actionTypes.GET_DISTRIBUTION_TREE_START
    };
};

export const getDistributionTreeSuccess = (children) => {
    return {
        type: actionTypes.GET_DISTRIBUTION_TREE_SUCCESS,
        children: children
    };
};

export const getDistributionTreeFail = (error) => {
    return {
        type: actionTypes.GET_DISTRIBUTION_TREE_FAIL,
        error: error
    };
};

export const getDistributionTree = () => {
    return dispatch => {
        dispatch(getDistributionTreeStart());
        /* TODO: VARIABLES FOR DISTRIBUTION TREE */
        window.flow.distprojectGetFullTree('pmdb_newstv', 0).then(res => {
            console.log("LAMTEST distprojectGetFullTree res", res);
            dispatch(getDistributionTreeSuccess(res.children));
        }).catch(res => {
            console.log(res);
            dispatch(getDistributionTreeFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    };
};

const getDistributionByDistStart = () => {
    return {
        type: actionTypes.GET_DISTRIBUTION_BY_DIST_START
    };
};

const getDistributionByDistSuccess = (distributions) => {
    return {
        type: actionTypes.GET_DISTRIBUTION_BY_DIST_SUCCESS,
        distributions: distributions
    };
};

const getDistributionByDistFail = (error) => {
    return {
        type: actionTypes.GET_DISTRIBUTION_BY_DIST_FAIL,
        error: error
    };
};

export const getDistributionByDist = () => {
    return dispatch => {
        dispatch(getDistributionByDistStart());

        /* TODO: VARIABLES FOR DISTRIBUTION TREE */
        window.flow.getDistprojectsForDist('pmdb_newstv', 0).then(res => {
            dispatch(getDistributionByDistSuccess(res.distproject.elements));
        }).catch(res => {
            dispatch(getDistributionByDistFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    };
};

// **** ADD CHILD DISTRIBUTION *** //
export const addDistributionChildStart = () => {
    return {
        type: actionTypes.DISTRIBUTION_CHILD_ADD_START
    }
};

export const addDistributionChildSuccess = (distribution) => {
    return {
        type: actionTypes.DISTRIBUTION_CHILD_ADD_SUCCESS,
        payload: { distribution: distribution }
    }
};

export const addDistributionChildFail = (error) => {
    return {
        type: actionTypes.DISTRIBUTION_CHILD_ADD_FAIL,
        error: error
    }
};


export const removeDistProjectFail = (err) => {
    return {
        type: actionTypes.DISTRIBUTION_REMOVE_PROJECT_FAIL,
        error: err
    }
}

export const removeDistProject = (distributionId) => {
    return (dispatch => {
        window.flow.delDistproject(distributionId)
            .then(res => {
                dispatch(getDistributionByDist());
                dispatch(getDistributionTree());
            })
            .catch(err => {
                removeDistProjectFail(err);
            })
    })
}
export const saveNewDistribution = (data) => {
    console.log("LAMTEST saveNewDistribution", data);
    return (dispatch => {
        window.flow.newDistproject("pmdb_newstv", 0, { 'title': data })
            .then(res => {
                console.log("LAMTEST saveNewDistribution RES", res);
                dispatch(getDistributionByDist());
                dispatch(getDistributionTree());
                if (res.data) dispatch(actions.setNewData({ project: { ...res.data, name: res.name } }));
            })
            .catch(err => console.log("LAMTEST saveNEWDIST err", JSON.stringify(err)))
    })
}

// parent: id of parent dist
// child: child dist object to add (or id)
export const addDistributionChild = (parent, child, reload = true) => {
    return (dispatch => {
        dispatch({ type: actionTypes.DISTRIBUTION_CHILD_ADD_START });
        window.flow.distprojectAddChild(parent, child).then(res => {
            // reload project tree
            if(reload) {
                dispatch(getDistributionTree());
            }
            // new child added
            dispatch({ type: actionTypes.DISTRIBUTION_CHILD_ADD_SUCCESS });
        }).catch(res => {
            // unable to add new child
            dispatch({ type: actionTypes.DISTRIBUTION_CHILD_ADD_FAIL });
        });
    });
}

export const addNewDistributionChild = (distributionId, title) => {
    console.log("LAMTEST addNewDistributionChild", distributionId, title);
    return (dispatch => {
        dispatch(addDistributionChildStart());
        window.flow.distprojectAddNewChild(distributionId, 'pmdb_newstv', 0, { 'title': title }).then(res => {
            console.log("LAMTEST addNewDistributionChild RES", res);
            // reload project tree
            dispatch(getDistributionByDist());
            dispatch(getDistributionTree());
            // new child added
            dispatch(addDistributionChildSuccess(res));
        }).catch(res => {
            // unable to add new child
            dispatch(addDistributionChildFail(res));
        });
    });
}

// clipIds: string of ids seperated by ','
export const removeClipsFromDistribution = (id, clipIds) => {
    return ((dispatch) => {
        let clips = Array.isArray(clipIds) ? clipIds.join(',') : clipIds;
        dispatch({ type: actionTypes.DISTRIBUTION_ADD_CLIPS_START });
        window.flow.distprojectRemoveClipById(id, clips).then(res => {
            dispatch({ type: actionTypes.DISTRIBUTION_ADD_CLIPS_SUCCESS });
            // reload cliplist
            dispatch(actions.getClipsForClipList(Metadata.OBJECT_TYPE_DISTRIBUTION, id));
        }).catch(res => {
            console.log(res);
            dispatch({ type: actionTypes.DISTRIBUTION_ADD_CLIPS_FAIL });
        });
    });
}

// clipIds: string of ids seperated by ','
export const addClipsToDistribution = (id, clipIds) => {
    return ((dispatch) => {
        let clips = Array.isArray(clipIds) ? clipIds.join(',') : clipIds;
        dispatch({ type: actionTypes.DISTRIBUTION_REMOVE_CLIPS_START });
        window.flow.distprojectAddClip(id, clips).then(res => {
            dispatch({ type: actionTypes.DISTRIBUTION_REMOVE_CLIPS_SUCCESS });
            // reload cliplist
            dispatch(actions.getClipsForClipList(Metadata.OBJECT_TYPE_DISTRIBUTION, id));
        }).catch(res => {
            console.log(res);
            dispatch({ type: actionTypes.DISTRIBUTION_REMOVE_CLIPS_FAIL });
        });
    });
}


export const getDistributionById = (id) => {
    return ((dispatch) => {
        dispatch({ type: actionTypes.DISTRIBUTION_GET_BY_ID_START });
        window.flow.getDistprojectById(id).then((dist) => {
            dispatch({ type: actionTypes.DISTRIBUTION_GET_BY_ID_SUCCESS, dist: dist });
            /*if (clipListId != getState().clipList.activeClipListId) {
                dispatch(actions.resetTickedClips());
                dispatch(actions.resetMultiSelected());
            }*/
            //dispatch(getClipsForClipListSuccess('project', clipList.id, clipList));
            //dispatch(setActiveProject(clipList.id));
        }).catch((res) => {
            console.log(res);
            //dispatch(getClipsForClipListFail(res.message));
            dispatch({ type: actionTypes.DISTRIBUTION_GET_BY_ID_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    });
}

export const saveDistprojectOrder = (distprojects) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.DISTRIBUTION_REORDER_START });
        const objs = distprojects.map(distproject => {
            return { id: distproject.getId(), metadata: { Order: distproject.getMetadata().fields.Order } };
        });
        window.flow.editDistprojects(objs).then((res) => {
            console.log("SUCCESS SAVE ORDER");
        }).catch((res) => {
            console.log(res);
        });
        dispatch({ type: actionTypes.DISTRIBUTION_REORDER_SUCCESS });
    }
}

export const getDistributionByDistWithType = (type, callback = false) => {
    return (dispatch, getState) => {
        dispatch({ type: actionTypes.GET_DISTRIBUTIONS_BY_TYPE_START, distType: type });
        window.flow.getDistprojectsForDist(type, 0, [{field: "archive", type: "=", value: "0"}]).then(res => {
            console.log(res);
            if(callback) {
                callback(res);
            }
            dispatch({ type: actionTypes.GET_DISTRIBUTIONS_BY_TYPE_SUCCESS, res: res, distType: type, config: getState().ui.config });
        }).catch(res => {
            dispatch(actions.applicationError(res.message));
            dispatch({ type: actionTypes.GET_DISTRIBUTIONS_BY_TYPE_FAIL, distType: type });
        });
    };
};

export const saveNewDistributionWithType = (type, meta) => {
    
    return (dispatch, getState) => {
        const config = getState().ui.config;
        let obj = {};
		if(meta) {
			if(typeof(meta) === 'object' && !Array.isArray(meta)) {
				obj = meta;
			} else if(typeof(meta) === 'string') {
				obj = { 'title': meta };
			}
		}
		
        window.flow.newDistproject(type, 0, obj).then(res => {
            // need to set hash to identify
            if(res && res.data.id && config.DIST_TREE_HASH && res.type in config.DIST_TREE_HASH) {
                console.log(encrypt(9408),encrypt(9420));
                const hash = encrypt(res.data.id);
                const field = config.DIST_TREE_HASH[res.type].field;
                dispatch(actions.updateMetadata(config.DIST_TREE_HASH[res.type].type, res.data.id, { [field]: hash  }));
            } else {
                dispatch(actions.getDistributionByDistWithType(type));
            }
        }).catch(res => {
            dispatch(actions.applicationError(res.message));
        });
    };
}

export const addNewDistributionChildWithType = (type, distId, meta) => {
    console.log(type,distId,meta);
    return (dispatch => {
		let obj = {};
		if(meta) {
			if(typeof(meta) === 'object' && !Array.isArray(meta)) {
				obj = meta;
			} else if(typeof(meta) === 'string') {
				obj = { 'title': meta };
			}
		}
		
        window.flow.distprojectAddNewChild(distId, type, 0, obj).then(res => {
            console.log(res);
            dispatch(actions.getDistributionByDistWithType(type));
        }).catch(res => {
           dispatch(actions.applicationError(res.message));
        });
    });
}

export const addDistributionChildWithType = (type, distId, meta) => {
    console.log(type,distId,meta);
    return (dispatch, getState) => {
        const config = getState().ui.config;
		let obj = {};
		if(meta) {
			if(typeof(meta) === 'object' && !Array.isArray(meta)) {
				obj = meta;
			} else if(typeof(meta) === 'string') {
				obj = { 'title': meta };
			}
		}
		
		window.flow.newDistproject(type, 0, obj).then(dist => {
            if(dist && dist.data && dist.data.id) {
                window.flow.distprojectAddChild(distId, dist.data.id).then(res => {
                    // need to set hash to identify
                    // reference to created distproject => dist
                    if(config.DIST_TREE_HASH && dist.type in config.DIST_TREE_HASH) {
                        console.log(encrypt(dist.data.id));
                        const hash = encrypt(dist.data.id);
                        const field = config.DIST_TREE_HASH[dist.type].field;
                        const callback = () => { dispatch(actions.getDistributionByDistWithType(type)) };
                        dispatch(actions.updateMetadata(config.DIST_TREE_HASH[dist.type].type, dist.data.id, { [field]: hash  }, [ callback ] ));
                    } else {
                        dispatch(actions.getDistributionByDistWithType(type));
                    }
                }).catch(res => {
                    dispatch(actions.applicationError(res.message));
                });
            } else {
                dispatch(actions.getDistributionByDistWithType(type));
            }
        }).catch(res => {
           dispatch(actions.applicationError(res.message));
        });
    };
}

export const removeDistProjectWithType = (distributionId, type, reload = true) => {
    return (dispatch => {
        window.flow.delDistproject(distributionId).then(res => {
            if(reload) {
                dispatch(actions.getDistributionByDistWithType(type));
            }
        }).catch(res => {
            dispatch(actions.applicationError(res.message));
        })
    })
}

const initCopyAsStatus = (dispatch, operation, title) => {
    const message = {
        operation: operation,
        title: title
    };

    dispatch({ type: actionTypes.STATUSBAR_SET_MESSAGE, message: message });
    
    return message;
}

const updateCopyAsStatus = (dispatch, msg) => {
    dispatch({ type: actionTypes.STATUSBAR_SET_MESSAGE, message: msg });
    dispatch({ type: actionTypes.STATUSBAR_RESET_MESSAGE });
}

export const distCopyAsProject = (title, clips) => {
  return (dispatch) => {
    if (title && title !== "") {
        const msg = initCopyAsStatus(dispatch, "COPY DISTRIBUTION AS PROJECT", title);
        window.flow.newProject({ 'name': title }).then(res => {
            if(clips.length) {
                window.flow.projectAddClip(res.id, clips.join(), "forceadd").then(r1 => {
                    // reload projects and  project tree
                    dispatch(actions.getProjectTree());
                    dispatch(actions.getProjects());
                    
                    updateCopyAsStatus(dispatch, { ...msg, status: "SUCCESS" });
                });
            } else {
                // reload projects and  project tree
                dispatch(actions.getProjectTree());
                dispatch(actions.getProjects());
                
                updateCopyAsStatus(dispatch, { ...msg, status: "SUCCESS" });
            }
        }).catch(res => {
            dispatch(actions.applicationError(res.message));
            updateCopyAsStatus(dispatch, { ...msg, status: "FAIL" });
        });
    }
  };
};

export const distCopyAsRoom = (title, clips) => {
  return (dispatch) => {
    if (title && title !== "") {
        const msg = initCopyAsStatus(dispatch, "COPY DISTRIBUTION AS ROOM", title);
        window.flow.newShowroom({ title: title }).then(res => {
            if(clips.length) {
                window.flow.projectAddClip(res.id, clips.join(), "forceadd").then(r1 => {
                    // reload 
                    dispatch(actions.getRooms());
                    updateCopyAsStatus(dispatch, { ...msg, status: "SUCCESS" });
                });
            } else {
                //reload
                dispatch(actions.getRooms());
                updateCopyAsStatus(dispatch, { ...msg, status: "SUCCESS" });
            }
        }).catch(res => {
            dispatch(actions.applicationError(res.message));
            updateCopyAsStatus(dispatch, { ...msg, status: "FAIL" });
        });
    }
  };
};


export const updateSplashComment = (obj) => {
    return dispatch => {
        if (obj) {
            console.log("LAMTEST UPDATECOMMENT obj", obj);
            window.flow.editComment({ ...obj, 'mode': 'EDIT' })
                .then(res => {
                    console.log("LAMTEST updateSplashComment res", res);
                })
                .catch(error => console.log(error));
        }
    }
}

export const saveSplashComment = (obj) => {
    return dispatch => {
        if (obj) {
            console.log("LAMTEST SAVECOMMENT obj", obj);
            // { comment, projectId, name, type }
            window.flow.editComment(obj).then(res => {
                console.log("LAMTEST saveSplashComment res", res);
            }).catch(err => {
                console.log("LAMTEST saveSplashComment err", err);
            });
        }
    };
};

export const getSplashComments = (obj) => {
    console.log("LAMTEST GETCOMMENTS obj", obj);
    return (dispatch, getState) => {
        const { shareSplash } = getState().share.shareObjects;
        console.log("LAMTEST GETCOMMENTS shareSplash", shareSplash);
        const { popUpObjects } = shareSplash;
        let updated = {};
        if (popUpObjects) updated = { ...popUpObjects };
        console.log("LAMTEST GETCOMMENTS updated", updated);
        window.flow.getComments(obj).then(res => {
            //console.log("LAMTEST getSplashComments res", res);
            if (res && res.comment && res.comment.elements) {
                //console.log("LAMTEST getSplashComments res.comment.elements", res.comment.elements);
                for (let i in res.comment.elements) {
                    let data = { ...res.comment.elements[i].data };
                    console.log("LAMTEST getSplashComments data", data);
                    if (!updated[data.type]) updated[data.type] = {};
                    updated[data.type][data.name] = data.comment;
                    //popUpObjects[data.type]['id'] = data.id;
                    updated[data.type][`${data.name}_original`] = data;
                    updated[data.type][`${data.name}_id`] = data.id;
                    dispatch(actions.updateShareObjects({ shareSplash: { ...shareSplash, saving: true, popUpObjects: { ...updated } } }))
                }
            }
        }).catch(res => {

        });
    };
};
